class ImageScroll extends HTMLElement {
    connectedCallback() {
      this.onScroll();
      window.addEventListener('scroll', this.onScroll.bind(this));
    }

    onScroll() {
      const items   = Array.from(this.querySelectorAll('.image-text-scroll__item'));
      const vh      = window.innerHeight;
      const scrollY = window.scrollY;

      const tops   = items.map(item => item.getBoundingClientRect().top + scrollY);
      const mids   = tops.map(top => top - vh * 0.5);
      const starts = tops.map((top, i) =>
        i === 0 ? top - vh * 0.75 : mids[i - 1]
      );

      const pcts = items.map((_, i) => {
        let pct = (scrollY - starts[i]) / (mids[i] - starts[i]);
        return Math.max(0, Math.min(1, pct));
      });

      items.forEach((item, i) => {
        const badge        = item.querySelector('.image-text-scroll__item-span');
        const content      = item.querySelector('.scroll__effect .content');
        const circle       = item.querySelector('.icon-circle');
        const intermediate = item.querySelector('.icon-intermediate');
        const flower       = item.querySelector('.icon-flower');
        const isLast       = (i === items.length - 1);

        const shouldBeActive = i === 0
          ? pcts[0] > 0
          : pcts[i - 1] >= 1;
        badge.classList.toggle('active', shouldBeActive);

        if (content) content.style.height = `${pcts[i] * 100}%`;

        if (i === 0) {
          if (pcts[0] === 0) {
            circle.style.display = 'block';
            intermediate.style.display = 'none';
            flower.style.display = 'none';
          } else if (pcts[0] < 1) {
            circle.style.display = 'none';
            intermediate.style.display = 'block';
            flower.style.display = 'none';
          } else {
            circle.style.display = 'none';
            intermediate.style.display = 'none';
            flower.style.display = 'block';
          }
        } else {
          if (pcts[i - 1] < 1) {
            circle.style.display = 'block';
            intermediate.style.display = 'none';
            flower.style.display = 'none';
          } else {
            if (isLast) {
              circle.style.display = 'none';
              intermediate.style.display = 'none';
              flower.style.display = 'block';
            } else {
              if (pcts[i] < 1) {
                circle.style.display = 'none';
                intermediate.style.display = 'block';
                flower.style.display = 'none';
              } else {
                circle.style.display = 'none';
                intermediate.style.display = 'none';
                flower.style.display = 'block';
              }
            }
          }
        }
      });
    }
  }

  customElements.define('image-text-scroll', ImageScroll);